import React from "react";
import { Dropdown, Menu, Tooltip } from "antd";
import { CloudDownloadOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { printFacutreService } from "../Services/PrintFactureService";


const ExportFacture = ({ numenreg}) => {
  const exportToPDF = () => {
    printFacutreService(numenreg);
  };

  const handleExport = () => {
    exportToPDF();
  };

 

  return (
    <Menu.Item  icon={<CloudDownloadOutlined style={{  color: 'red'}} />} onClick={handleExport}>
                Télécharger Facture
            </Menu.Item>
  );
};

export default ExportFacture;